window.$ = window.jQuery = require('jquery');

/**
 * @class
 */
export default class ChooseTeethsModal {
	/**
	 * Initialize Header
	 * @function
	 */
	constructor(el) {
		this.el = el;


		if(!this.el.length) {
			return;
		}
		this.chooseTeethModal = $('#choose-teeth-modal');
		this.modalTitle = this.chooseTeethModal.find('.modal-title');
		this.teethMap = this.chooseTeethModal.find('.teeth-map');
		this.bindEvents();
	}



	
	bindEvents() {
		this.el.change((event) => {
			if(this.el.is(":checked")) {
				this.chooseTeethModal.modal("show");
                                this.chooseTeethModal.find('input:checked').click();
				this.modalTitle.text(this.el.attr('data-choose-teeths'));
				this.teethMap.attr('data-for-group', this.el.attr('data-choose-teeths'));
			} else {
                                this.chooseTeethModal.find('input:checked').click();
				this.el.closest('.field-lbl').find('.lbl-teeth').remove();
			}
    });
	}

}
